/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {
    Timeline,
    TimelineMax,
    TimelineLite,
    TweenLite,
    TweenMax,
    Ease,
    Linear,
    Power2,
    Power1,
    Power0,
    Power3,
    Power4,
    Expo,
    Elastic
} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpacierArcadeScatterSymbol} from "../symbols/SpacierArcadeScatterSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";

export class SpinStop implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;
    private _prevMultiplier:number;
    protected _scatterPositions:number[];

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
        this._prevMultiplier = 0;
    }

    public prepare(data:SpacierArcadeParsedGameData):void {
        this._scatterPositions = data.scatterPositions != null ? data.scatterPositions : ArrayHelper.initArrayWithValues(GameConfig.instance.REELS_NUM, () => -1);
    }


    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this.resetScatterToNormalState(data), GameSetting.isFastSpin ? "-=0.2": "-=0.25");
        tl.add(()=>{
            if(SoundConfig.instance.REELS_SPIN_START) {
                SlotGame.sound.stopEffect(SoundConfig.instance.REELS_SPIN_START[0]);
            }
        },GameSetting.isFastSpin ? 0.5: 0.2);

        return tl;
    }

    private resetScatterToNormalState(data:SpacierArcadeParsedGameData):Timeline{
        const tl:TimelineLite = new TimelineLite();
        let scatterSymbolsLength: number = this._scatterPositions.filter((posSca) => {return posSca > -1;}).length;
        if(!data.freespinTriggeredThisSpin && scatterSymbolsLength > 0){
            for(let i:number = 1; i < 4; i++) {
                tl.add(this.playSymbolAttentionAnimation(i, SpacierArcadeGameConfig.instance.SYMBOL_STATES.attention));
            }
        }
        return tl;
    }

    private playSymbolAttentionAnimation(reelId:number, state:ISymbolStateConfig, scatterCount:number = 1):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add( () => {
            const scatter: SpacierArcadeScatterSymbol | null = <SpacierArcadeScatterSymbol>Reels.getSymbol(reelId, this._scatterPositions[reelId]);
            if (scatter) {
                scatter.changeState({
                    state: state
                });
            }
        });
        return timeline;
    }

    public abort(isActive:boolean, data:SpacierArcadeParsedGameData):Timeline | null {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this.resetScatterToNormalState(data), "-=0.25");
        tl.add(()=>{
            if(SoundConfig.instance.REELS_SPIN_START) {
                SlotGame.sound.stopEffect(SoundConfig.instance.REELS_SPIN_START[0]);
            }
        }, 0.5);
        return tl;
    }

}